import { axiosInstance } from "@/lib/api/client";
import { useCurrentUser } from "@/lib/hooks/useCurrentUser";
import { FormLoader } from "./FormLoader";
import { OfflineStatus } from "@rumble-it/common-components/components";
import { useQuery } from "@tanstack/react-query";
import { getFormConfigurationsByType } from "@/pages/dealer-intake/lib/queries/getFormConfigurationsByType";

export const DealerIntake = () => {
  const currentUser = useCurrentUser();

  const servicePartners = currentUser?.role?.servicePartners || [];
  const dealership = currentUser?.role?.dealership || null;

  if (!dealership && servicePartners.length === 0) {
    throw new Error(
      "User must be associated with at least one dealership or service partner to access the Dealer Intake form.",
    );
  }

  const schemasQuery = useQuery({
    queryKey: ["formConfigurations", "repair-direct-generic-dealer-intake-v2"],
    queryFn: async () => {
      const availableForms = await getFormConfigurationsByType(
        "repair-direct-generic-dealer-intake-v2",
      );
      if (!availableForms || availableForms.length === 0) {
        throw new Error(
          `No form configurations found for type "repair-direct-generic-dealer-intake-v2".`,
        );
      }
      if (availableForms.length !== 1) {
        throw new Error(
          `Expected exactly one form configuration for type "repair-direct-generic-dealer-intake-v2", but found ${availableForms.length}.`,
        );
      }
      return availableForms[0];
    },
  });

  const formId = schemasQuery.data?.id;

  if (schemasQuery.isLoading) return null;

  return (
    <>
      <OfflineStatus />
      <FormLoader
        api={axiosInstance}
        config={{ formId }} // hide if fetching forms.
        context={{
          dealership,
          servicePartners,
        }}
      />
    </>
  );
};
